import React from "react";

import imageOne from "../../resource/arama/secureSpot/2.png";
import imageFour from "../../resource/arama/secureSpot/4.png";
import imageFive from "../../resource/arama/secureSpot/5.png";
import imageThree from "../../resource/arama/secureSpot/1.png";
import TitleChnage from "../../Hook/TitleChnage";
import imageSix from "../../resource/arama/secureSpot/3.png";
import imageSeven from "../../resource/arama/secureSpot/8.png";
import imageEight from "../../resource/arama/secureSpot/9.png";
import imageNine from "../../resource/arama/secureSpot/13.png";

import { useNavigate } from "react-router-dom";
import tableImage from "../../resource/arama/secureSpot/6.png";

import plan from "../../resource/arama/secureSpot/Screenshot from 2024-12-03 17-51-26.png";

const Securespot = () => {
  TitleChnage("Secure Spot");
  const navigate = useNavigate();

  const handleClick = (event) => {
    const pathMap = {
      landLotRequest: "/landLotRequest",
      fiveYearRequest: "/fiveYearRequest",
      membershopforfiveyear:'/membershopforfiveyear'
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };
  return (
    <div className="securespot-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main  p-4 mt-4">Annual Ceremony</h1>
      <h1 className="h4 text-bold  p-4 mt-5">Secure Your Land Plot</h1>

      <p className="mt-5 h4 p-4">
        Bhaddeka Vihari Monastery and Meditation Centre is nestled within a vast
        42-acre land. While it might be challenging for an individual to offer
        the entire land for a monastery, we have made it possible for you to
        contribute to this sacred land by dividing it into smaller, affordable
        plots. This allows many generous donors to come together and
        collectively offer the entire 42-acre site.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">How You Can Participate</h3>

      <p className="mt-5 h4 p-4">
        Now you have the unique opportunity to purchase and offer a land plot
        within this 42-acre area. Each plot is available for $500, and you will
        receive a “Certificate of Gratitude” of offering called "Sannaspathra"
        to the Arama. This collective effort will allow the community to come
        together and foster a sense of generosity and shared responsibility.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">Benefits of Participating:</h3>

      <p className="mt-5 h4 p-4">
        • Perpetual Offering: By securing a plot, you are contributing to a
        lasting shelter for spiritual practitioners and supporting the
        monastery's growth and maintenance for generations to come.
      </p>
      <p className="mt-5 h4 p-4">
        • Fostering Generosity: Your contribution will not only benefit the
        present community but also set a foundation for future generations of
        practitioners. It is an act of profound generosity, cultivating the
        fragrant quality of giving that enriches the spiritual community.
      </p>

      <p className="mt-5 h4 p-4">
        • Supporting the Sasana: Your participation helps maintain and expand
        the Buddhist community (Sasana) through both physical and spiritual
        growth, ensuring that the monastery remains a thriving spiritual haven.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">Spiritual Significance:</h3>
      <p className="mt-5 h4 p-4">
        This act of offering a plot is not merely a physical contribution but
        also a deeply spiritual one. The merit of supporting a monastery and its
        mission is immense, as illustrated in the Jetavana Sutta. In this sutta,
        Anatapindika Deva Puttha expresses his joy and satisfaction upon seeing
        the Jetavana, which he had offered to the Buddha in a past life. The
        offering of land for the benefit of the Dhamma and the monastic
        community is a powerful means of generating lasting merit.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">Join the Arama Pooja</h3>
      <p className="mt-5 h4 p-4">
        Now you have two options for participating in the Arama Pooja, both
        providing an opportunity to contribute to this noble and meritorious
        cause. One option is to directly donate for a land lot as part of the
        Arama pooja. Here you have the option to donate for a single land lot
        or, if you wish, contribute to multiple land lots. Second option is
        being part of the Five-Year Arama Pooja Project, which also allows to
        contribute to multiple land plots.{" "}
      </p>

      <h3 className="font-second text-bold p-4 mt-6 text-center">
        1. Arama Pooja Land Lot Project
      </h3>
      <p className="mt-5 h4 p-4">
        Now you have two options for participating in the Arama Pooja, both
        providing an opportunity to contribute to this noble and meritorious
        cause. One option is to directly donate for a land lot as part of the
        Arama pooja. Here you have the option to donate for a single land lot
        or, if you wish, contribute to multiple land lots. Second option is
        being part of the Five-Year Arama Pooja Project, which also allows to
        contribute to multiple land plots.{" "}
      </p>

      <img
        src={plan}
        alt="image of plan"
        className="plan mt-6"
        style={{ width: "100%" }}
      />

      <div className="btn-group-flex mt-6">
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
      </div>

      <div className="btn-group-flex mt-5">
        <img
          src={imageNine}
          alt="Right Top Image"
          width={300}
          className="right-image curser-pointer"
          id="landLotRequest"
          onClick={handleClick}
        />
      </div>

      <div className="bottom-box mt-6">
        <img src={imageSeven} alt="bottom-image" width={600} />
      </div>

      <h1 className="font-second mt-6 text-center p-4">
        2. Arama Pooja - Five Years Project{" "}
      </h1>
      <p className="mt-5 h4 p-4">
        The establishment of an Arama (Buddhist Monastery) is a noble and
        significant undertaking, but offering a large piece of land for such a
        purpose can often be financially challenging for an individual. However,
        by dividing the land into smaller plots, it becomes more accessible and
        affordable for multiple donors. The Bhaddeka Vihari Monastery and
        Meditation Centre is providing an opportunity for individuals or groups
        to purchase a plot of land valued at $500 and contribute it to the
        creation of an Arama. A Sannaspathra (Certificate of Gratitude) will be
        issued to each donor in recognition of their contribution.
      </p>
      <p className="mt-5 h4 p-4">
        This collective effort allows donors to play an integral role in
        offering a piece of land for the Arama. The entire land for the Arama
        will be formed through these donations.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">
        Payment Scheme for Land Purchase
      </h3>
      <p className="mt-5 h4 p-4">
        For those who wish to purchase land plots but are unable to make the
        full payment at once, the project offers a structured premium payment
        plan over a five-year period. The following are the options available:
      </p>
      <div className="p-4 text-center mt-5">
        <img src={tableImage} alt="image" width={600} className="tableimage" />
      </div>

      <p className="mt-5 h4 p-4">
        Establishing a place to offer the Dhamma, such as a Monastary or
        Meditation center, is not merely a simple gift to the Sasana (the
        Buddhist community). It is a monumental contribution that creates an
        enormous field of merits. These places become sanctuaries where people
        can learn, practice, and share the Dhamma, fostering spiritual growth
        and well-being in the community benefiting not only the current
        generation but also future ones.
      </p>

      <div className="btn-group-flex mt-6">
        <img src={imageSix} alt="Right Top Image" width={300}  className="right-image curser-pointer"
              id="membershopforfiveyear"
              onClick={handleClick} />
      </div>
      <div className="btn-group-flex mt-5">
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
      </div>
      <p className="mt-6 h4 p-4">
        Your participation in this noble project will help create a lasting
        legacy for the Dhamma and contribute to the flourishing of Buddhist
        teachings for generations to come.
      </p>

      <h3 className="h4 text-bold p-4 mt-5">Jetavana Sutta Reference:</h3>
      <p className="mt-5 h4 p-4">
        In the Sanyutta Nikāya 1.48, specifically in the Ādittavagga, the
        Jetavana Sutta, we read:
      </p>
      <p className="mt-5 h4 p-4">
        "Idañhi taṃ jetavanaṃ, isisaṃghanisevitaṃ; Āvutthaṃ dhammarājena,
        pītisañjananaṃ mama"
      </p>

      <div className="p-4 mt-6 text-center">
        <p className=" h4 mt-4 ">This translates to:</p>
        <p className=" h4  mt-4 ">This indeed is that Jeta’s Grove,</p>
        <p className=" h4  mt-4 ">The resort of the Order of seers,</p>
        <p className=" h4  mt-4 ">where the King of Dhamma stayed,</p>
        <p className=" h4   mt-4">
          A place that gives me joy, correct and beautiful."
        </p>
      </div>

      <p className="mt-6 h4 p-4">
        In this verse, the joy of Anatapindika Deva Puttha in seeing the land he
        offered to the Buddha is expressed. It serves as a reminder that through
        such offerings, the land becomes a sacred space that benefits both the
        current and future generations of practitioners
      </p>

      <div className="p-4 mt-6 text-center">
        <div className="mt-6 calander-box align-item-center">
          <div className="c-details text-left">
            <h2 className="intro-text ">Futher More Details : </h2>
            <p className="font-p mt-4">
              Monastery : 035608 0918 / 0459 729 738
            </p>
            <p className="font-p">Mr Gamini : 0422 069 359</p>
            <p className="font-p">WhatsApp : 0422 069 359</p>
            <p className="font-p">E-mail : info@bvp.org.au</p>
          </div>

          <div className="d-button">
            <img
              src={imageEight}
              alt="Right Top Image"
              width={300}
              className="right-image curser-pointer"
              id="fiveYearRequest"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default Securespot;
